<template>
    <div class="card">
        <div class="card-content">
            <div class="content">
                <h1 class="title">Vérification</h1>

                <div class="columns">
                    <div class="column">
                        <b-field>
                            <b-button
                                    type="is-success"
                                    icon-pack="fas"
                                    icon-left="check"
                                    @click.prevent="verify()">
                                Vérifier le projet
                            </b-button>
                        </b-field>
                    </div>
                    <div class="column">
                        TO DO
                    </div>
                </div>

                <hr>
                <h3 class="subtitle">
                    <b-icon
                            :type="status_project ? 'is-success' : 'is-warning'"
                            icon="circle">
                    </b-icon>
                    Project
                </h3>
                <h3 class="subtitle">
                    <b-icon
                            :type="status_td ? 'is-success' : 'is-danger'"
                            icon="circle">
                    </b-icon>
                    Frais de personnel
                </h3>
                <h3 class="subtitle">
                    <b-icon
                            :type="status_fm ? 'is-success' : 'is-warning'"
                            icon="circle">
                    </b-icon>
                    Frais de mission
                </h3>
                <h3 class="subtitle">
                    <b-icon
                            :type="status_mat ? 'is-success' : 'is-warning'"
                            icon="circle">
                    </b-icon>
                    Achat de matériel
                </h3>
                <h3 class="subtitle">
                    <b-icon
                            :type="status_sst ? 'is-success' : 'is-warning'"
                            icon="circle">
                    </b-icon>
                    Sous-traitance
                </h3>
                <h3 class="subtitle">
                    <b-icon
                            :type="status_fi ? 'is-success' : 'is-danger'"
                            icon="circle">
                    </b-icon>
                    Financeurs
                </h3>
                <h3 class="subtitle">
                    <b-icon
                            :type="status_p1 ? 'is-success' : 'is-warning'"
                            icon="circle">
                    </b-icon>
                    Fiche de présentation
                </h3>
                <h3 class="subtitle">
                    <b-icon
                            :type="status_p2 ? 'is-success' : 'is-warning'"
                            icon="circle">
                    </b-icon>
                    Fiche de présentation 2

                </h3>

                <div class="buttons">
                    <b-button
                            type="is-info"
                            icon-pack="fas"
                            icon-right="file"
                            @click.prevent="saveToPC()">
                        Exporter mon projet en JSON
                    </b-button>
                    <b-button
                            type="is-success"
                            icon-pack="fas"
                            icon-right="save"
                            @click.prevent="saveToDB()">
                        Enregistrer mon projet en base de donnée
                    </b-button>
                </div>

                <b-modal :active.sync="isAttachmentsModalActive" has-modal-card>
                    <Attachments
                            :docid="docid()"
                    ></Attachments>
                </b-modal>

            </div>


        </div>

    </div>
</template>

<script>

    import Attachments from "./Attachments";

    export default {
        name: "Verification",
        components: {Attachments},
        props: {
            rev: {
                required: true
            },
            synth: {
                type: Object,
                required: true
            }
        },
        mounted() {

        },
        computed: {},
        watch: {},
        methods: {
            docid(){
                return localStorage.getItem("_id") ? JSON.parse(localStorage.getItem("_id")) : this.idProject;
            },
            makeJSON() {
                const post = {};
                post.project        = JSON.parse(localStorage.getItem("project"));
                post.td             = JSON.parse(localStorage.getItem("td"));
                post.fm             = JSON.parse(localStorage.getItem("fm"));
                post.mat            = JSON.parse(localStorage.getItem("mat"));
                post.sst            = JSON.parse(localStorage.getItem("sst"));
                post.fi             = JSON.parse(localStorage.getItem("fi"));
                post.p1             = JSON.parse(localStorage.getItem("p1"));
                post.p2             = JSON.parse(localStorage.getItem("p2"));
                post.synth          = this.synth
                return post;
            },
            saveToPC() {
                let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.makeJSON()));
                let downloadAnchorNode = document.createElement('a');
                downloadAnchorNode.setAttribute("href", dataStr);
                let filename = `${this.makeJSON().project.fullName}-${Date.now()}`
                downloadAnchorNode.setAttribute("download", `${filename}.json`);
                document.body.appendChild(downloadAnchorNode); // required for firefox
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
            },
            saveToDB() {
                let doc             = this.makeJSON();
                let rev             = localStorage.getItem("_rev") ? JSON.parse(localStorage.getItem("_rev")) : false;
                let id              = localStorage.getItem("_id") ? JSON.parse(localStorage.getItem("_id")) : false;

                let attachments;
                if (localStorage.getItem("_attachments")) {
                    attachments = localStorage.getItem("_attachments") !== "undefined" ? JSON.parse(localStorage.getItem("_attachments")) : false;
                } else {
                    attachments = false
                }

                this.$axios.post('save', {doc: doc, _id: id, _rev: rev, _attachments: attachments}, {})
                    .then((res) => {
                        if (res.data.status === "KO") {
                            this.$buefy.dialog.alert({
                                title: `Une erreur est survenue`,
                                type: "is-danger",
                                confirmText: "Revenir sur ma saisie",
                                hasIcon: true,
                                message: `Il semblerait que cette phase soit déjà enregistrée pour ce projet.
                                Merci de passer par la fonction d'édition pour la modifier, ou vérifier l'étape 1 sur les champs Projet et Phase.`,
                            });
                        } else {
                            //handle success
                            this.idProject = res.data.docid
                            this.$buefy.dialog.confirm({
                                title: `Enregistrement en base de données`,
                                confirmText: "Oui",
                                cancelText: "Non",
                                type: "is-success",
                                hasIcon: true,
                                message: `Votre projet a bien été enregistré en base de données, voulez-vous ajouter des pièces-jointes ?`,
                                onConfirm: () => {
                                    this.isAttachmentsModalActive = true;
                                },
                                onCancel: () => {
                                    this.$router.push('/liste');
                                }
                            });
                        }
                    })
                    .catch(function (error) {
                        //handle error
                        console.log(error);
                    });
            },
            verify() {
                this.status_project = !!localStorage.getItem("project");
                this.status_td = !!localStorage.getItem("td");
                this.status_fm = !!localStorage.getItem("fm");
                this.status_mat = !!localStorage.getItem("mat");
                this.status_sst = !!localStorage.getItem("sst");
                this.status_fi = !!localStorage.getItem("fi");
                this.status_p1 = !!localStorage.getItem("p1");
                this.status_p2 = !!localStorage.getItem("p2");
            }
        },
        data() {
            return {
                status_project: false,
                status_td: false,
                status_fm: false,
                status_mat: false,
                status_sst: false,
                status_fi: false,
                status_p1: false,
                status_p2: false,
                isSynthModalActive: false,
                isAttachmentsModalActive: false,
                idProject: '',
            }
        },

    }

</script>

<style scoped>

.upload {
  height: 70px;
  padding: 0px;
}

.up-margin {
  padding: 10px;
}

</style>
